export default "__VITE_ASSET__DCLAPjPY__"